import { gql } from 'graphql-tag';
export const DISCUSSION_GET = gql `
  query Discussion($externalId: String!) {
    Discussion(externalId: $externalId) {
      id
      externalId
      createdAt
      updatedAt
    }
  }
`;
export const COMMENT_DEEP_FRAGMENT = `
  fragment CommentDeepFragment on Comment {
    id
    body
    childrenCount
    createdAt
    updatedAt
    user {
      id
      name
      picture
    }
  }
`;
export const COMMENTS_GET = gql `
  query allComments(
    $discussionId: Float!,
    $parentId: Float,
    $perPage: Int,
    $page: Int,
    $sortField: String,
    $sortOrder: String,
  ) {
    meta: _allCommentsMeta(
      discussionId: $discussionId
      parentId: $parentId
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      count
      nextPage
      page
      pageCount
      perPage
      prevPage
    }

    comments: allComments(
      discussionId: $discussionId
      parentId: $parentId
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      ...CommentDeepFragment
    }
  }
  ${COMMENT_DEEP_FRAGMENT}
`;
export const COMMENT_CREATE = gql `
  mutation createComment(
    $discussionId: Int!
    $body: String!
    $parentId: Int
  ) {
    comment: createComment(
      discussionId: $discussionId
      body: $body
      parentId: $parentId
    ) {
      ...CommentDeepFragment
    }
  }
  ${COMMENT_DEEP_FRAGMENT}
`;
export const COMMENT_DELETE = gql `
  mutation deleteComment(
    $id: ID!
  ) {
    comment: deleteComment(id: $id) {
      ...CommentDeepFragment
    }
  }
  ${COMMENT_DEEP_FRAGMENT}
`;
//# sourceMappingURL=queries.js.map